import { BulkEditOwnerRequest, PartRequestBulkItemDto } from '../types';

export const createOwnerRequest = (row: PartRequestBulkItemDto): BulkEditOwnerRequest => {
  return {
    lineId: row.lineId,
    ownerId: row.ownerId,
    selected: false,
  };
};
